import { IRegisterData, IRegisterTextInfo } from '../interfaces';

export const MILITARY_STATUS_REGISTERPAGE = [
  'active-duty-education-guide',
  'spouse-education-guide',
  'veteran-education-guide',
];

export const REGISTER_PAGE_DATA: IRegisterData[] = [
  {
    name: 'register',
    data: {
      title: `Find the <span class="text-secondary">Right School</span> for You`,
      ptext: '',
      subtitle:
        'We help you find the best fit for schools, scholarships and more, for veterans, military, and their families.',
      bulletTitle: 'How does CollegeRecon help the Military Community?',
      downloadText: '',
      bulletData: [
        {
          icon: 'pi-globe',
          btitle: '',
          title:
            'We provide you with direct access to a network of over 2,800 colleges and universities all in one place.',
        },
        {
          icon: 'pi-question',
          btitle: '',
          title:
            'You can connect with campus administrators who work specifically with college-bound military personnel to ensure your questions are answered properly.',
        },
      ],
      lasttext: 'Everything we do for the military is FREE!',
      backgroundSrc: '/assets/img/reg-background.jpg',
    },
  },
  {
    name: 'va-disability',
    data: {
      title: `Find the <span class="text-secondary">Right School</span> for You`,
      ptext: '',
      subtitle:
        'We help you find the best fit for schools, scholarships and more, for veterans, military, and their families.',
      bulletTitle: 'How does CollegeRecon help the Military Community?',
      downloadText: '',
      bulletData: [
        {
          icon: 'pi-globe',
          btitle: '',
          title:
            'We provide you with direct access to a network of over 2,800 colleges and universities all in one place.',
        },
        {
          icon: 'pi-question',
          btitle: '',
          title:
            'You can connect with campus administrators who work specifically with college-bound military personnel to ensure your questions are answered properly.',
        },
      ],
      lasttext: 'Everything we do for the military is FREE!',
      backgroundSrc: '/assets/img/reg-background.jpg',
    },
  },
  {
    name: 'media',
    data: {
      title: `Find the <span class="text-secondary">Right School</span> for You`,
      ptext: '',
      subtitle:
        'We help veterans, military, and their families find the best fit for schools, scholarships, and more.',
      bulletTitle: 'How does CollegeRecon help the Military Community?',
      downloadText: '',
      bulletData: [
        {
          icon: 'pi-globe',
          btitle: '',
          title:
            'We provide you with direct access to a network of over 7,000 colleges and universities all in one place.',
        },
        {
          icon: 'pi-question',
          btitle: '',
          title:
            'You can connect with campus administrators who work specifically with college-bound military personnel to ensure your questions are answered properly.',
        },
      ],
      lasttext: 'Everything we do for the military is FREE!',
      backgroundSrc: '/assets/img/reg-background.jpg',
    },
  },
  {
    name: 'active-duty-education-guide',
    data: {
      title: `Education Guide for <span class="text-secondary">Active Duty Service Members, National Guard & Reserve</span>`,
      ptext: '',
      subtitle:
        'Ready to go to school but don’t know where to start? This guide is here to help you understand your benefits, discover additional ways to pay for your education, and find the perfect school for you.',
      downloadText: 'Download the Step-by-Step Active Duty Education Guide',
      bulletTitle: 'How can this guide help you?',
      bulletData: [
        {
          icon: 'pi-circle-fill',
          btitle: 'Learn about education benefits to help pay for school.',
          title:
            'Benefits such as about Tuition Assistance (TA), Top-Up (TATU), and state tuition assistance and the steps needed to use them.',
        },
        {
          icon: 'pi-circle-fill',
          btitle: 'Step-by-step guide.',
          title:
            'Our guide will start you on the right path to develop a plan to clarify what’s important to you to eventually determine which schools will best help you reach those goals.',
        },
        {
          icon: 'pi-circle-fill',
          btitle: 'Finding the right school.',
          title:
            'Search schools that offer your preferred degree program, has the right support programs in place, is approved for tuition assistance funding, and provides credit for military experience.',
        },
        {
          icon: 'pi-circle-fill',
          btitle: 'Resources for active duty military.',
          title:
            'We’ve compiled free education, benefits,and career resources to assist you.  We’ve included convenient access to required documents to help ensure you receive all the financial benefits available to you.',
        },
      ],
      download: {
        imageSrc: '/assets/img/thumb-active-duty.png',
        text: 'Download the Step-by-Step Active Duty Education Guide',
      },
      lasttext: 'Everything we do for the military is FREE!',
      backgroundSrc: '/assets/img/active-duty-bck-img.jpg',
    },
  },
  {
    name: 'veteran-education-guide',
    data: {
      title: `Education Guide for <span class="text-secondary">Veterans & Retirees</span>`,
      ptext: 'Thank you for signing up with CollegeRecon!',
      subtitle:
        'Ready to go to school but don’t know where to start? This guide is here to help you understand your benefits, explore additional ways to pay for school, and learn about more education benefits and programs out there to assist veterans in going to school.',
      downloadText: 'Download the Step-by-Step Veterans’ Education Guide',
      bulletTitle: 'How can this guide help you?',
      bulletData: [
        {
          icon: 'pi-circle-fill',
          btitle: 'Learn about education benefits to help pay for school.',
          title:
            'Learn about using the Post 9/11 GI Bill, the Yellow Ribbon Program, the Montgomery GI Bill, and other programs and the steps needed to use them.',
        },
        {
          icon: 'pi-circle-fill',
          btitle: 'Step-by-step guide.',
          title:
            'Our guide will start you on the right path to develop a plan to clarify what’s important to you to eventually determine which schools will best help you reach those goals.',
        },
        {
          icon: 'pi-circle-fill',
          btitle: 'Finding the right school.',
          title:
            'Search schools that offer the degree program you’re looking for, is approved for MyCAA or GI Bill funding, and provides discounts and scholarships for military spouses and dependents.',
        },
        {
          icon: 'pi-circle-fill',
          btitle: 'Resources for military spouses, dependents, and families.',
          title:
            'We’ve compiled free education, benefits,and career resources to assist you.  We’ve included convenient access to required documents to help ensure you receive all the financial benefits available to you.',
        },
      ],
      download: {
        imageSrc: '/assets/img/thumb-veteran.png',
        text: 'Download the Step-by-Step Veterans’ Education Guide',
      },
      lasttext: 'Everything we do for the military is FREE!',
      backgroundSrc: '/assets/img/veteran-bck-img.jpg',
    },
  },
  {
    name: 'spouse-education-guide',
    data: {
      title: `Education Guide for <span class="text-secondary">Military Spouses & Dependents<span class="text-secondary">`,
      ptext: '',
      subtitle:
        'Ready to go to school but don’t know where to start? This guide is here to help you understand your benefits, discover additional ways to pay for your education, and find the perfect school for you.',
      downloadText:
        'Download the Step-by-Step Military Spouses’ Education Guide',
      bulletTitle: 'How can this guide help you?',
      bulletData: [
        {
          icon: 'pi-circle-fill',
          btitle:
            'Learn about benefits and scholarship programs to help pay for school.',
          title:
            'Learn about MYCAA, scholarships & grants for military spouses and dependents, and the steps needed to use them.',
        },
        {
          icon: 'pi-circle-fill',
          btitle: 'Step-by-step guide.',
          title:
            'Our guide will start you on the right path to develop a plan to clarify what’s important to you to eventually determine which schools will best help you reach those goals.',
        },
        {
          icon: 'pi-circle-fill',
          btitle: 'Finding the right school.',
          title:
            'Search schools that offer the degree program you’re looking for, is approved for MyCAA or GI Bill funding, and provides discounts and scholarships for military spouses and dependents.',
        },
        {
          icon: 'pi-circle-fill',
          btitle: 'Resources for military spouses, dependents, and families.',
          title:
            'We’ve compiled free education, benefits,and career resources to assist you.  We’ve included convenient access to required documents to help ensure you receive all the financial benefits available to you.',
        },
      ],
      download: {
        imageSrc: '/assets/img/thumb-spouse.png',
        text: 'Download the Step-by-Step Military Spouses’ Education Guide',
      },
      lasttext: 'Everything we do for the military is FREE!',
      backgroundSrc: '/assets/img/spouse-bck-img.jpg',
    },
  },
  {
    name: 'bah',
    data: {
      title: `Save Your <span class="text-secondary">Housing Allowance</span> Info!`,
      ptext: '',
      subtitle:
        'Get quick and easy access to your Housing Allowance Information.',
      bulletTitle: 'How do we help the military community?',
      downloadText: '',
      bulletData: [
        {
          icon: 'pi-circle-fill',
          btitle: '',
          title:
            'Compare and save multiple housing allowance rates for BAH, OHA, and GI Bill!',
        },
        {
          icon: 'pi-circle-fill',
          btitle: '',
          title:
            'Automatically updated each year when the new rates are made available!',
        },
        {
          icon: 'pi-circle-fill',
          btitle: '',
          title:
            'Quick, easy access to your BAH, OHA, or GI Bill MHA housing allowance information!',
        },
        {
          icon: 'pi-circle-fill',
          btitle: '',
          title:
            'Automated emails: receive an email with your updated information each year!',
        },
      ],
      lasttext: '',
      backgroundSrc: '/assets/img/reg-background.jpg',
    },
  },

  {
    name: 'pay-calculator',
    data: {
      title: `Military Pay & Benefits Updates from <span class="text-secondary">MyMilitaryBenefits</span>`,
      ptext: '',
      subtitle: 'Never Miss Military Pay and Benefits Updates!',
      bulletTitle: '',
      downloadText: '',
      bulletData: [],
      lasttext:
        'Receive military pay updates on proposed pay increases, new pay chart info, and benefits updates impacting you and your family directly to your inbox. Always free from MyMilitaryBenefits!',
      backgroundSrc: '/assets/img/reg-background.jpg',
    },
  },

  {
    name: 'gi-bill-calculator',
    data: {
      title: `Military & Veteran Benefits Updates from MyMilitaryBenefits`,
      ptext: '',
      subtitle:
        'Never Miss Military & Veteran Benefits Updates! Receive benefits updates impacting you and your family directly to your inbox. Always free from MyMilitaryBenefits!',
      bulletTitle: 'Sign up now:',
      downloadText: '',
      bulletData: [
        {
          icon: 'pi-circle-fill',
          btitle: '',
          title: 'Never miss benefits updates impacting you and your family',
        },
        {
          icon: 'pi-circle-fill',
          btitle: '',
          title: 'Stay up-to-date on military & veteran benefits updates',
        },
      ],
      lasttext: '',
      backgroundSrc: '/assets/img/reg-background.jpg',
    },
  },
];
